/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import { PlayService } from '../services/play.service';

const actions = {
  getSettings: async ({}) => {
    try {
      const { donation } = await PlayService.getConfig();
      return donation;
    } catch (e) {
      return null;
    }
  },
  updateSettings: async ({}, payload) => {
    try {
      await PlayService.updateConfig(payload);
      return true;
    } catch (e) {
      return false;
    }
  },
};

export default {
  namespaced: true,
  actions,
};
